export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`brand ${compact ? 'brand--compact' : ''}`} aria-label="Logica Stream">
      <span className="brand__mark" aria-hidden="true"><i /><i /><i /></span>
      <span className="brand__copy"><strong>Logica</strong><small>Stream</small></span>
    </div>
  );
}
